import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import Lottie from "lottie-react";
import ImageLogin from "../../../assets/images/loginImg.png";
import logo from "../../../assets/images/Paxity.png";
import successAnim from "../../../assets/animations/passwordAuthentication.json";
import "../utils/login.css";

const QRCodeResetSuccess = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(20);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          navigate("/login-merchant");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="my-box d-flex">
      <div className="left-box">
        <div className="py-2 px-md-5">
          <div className="mt-0 mb-3">
            <img
              src={logo}
              alt="Logo"
              style={{ width: "167px", height: "39px" }}
            />
          </div>

          <div className="auth-heading-wrapper">
            <div className="connected">Réinitialisation QR réussie</div>
            <p className="texteLogin mt-4 mb-2">
              Votre authentification à deux facteurs a été réinitialisée avec succès. <br />
              Vous pouvez vous reconnecter et scanner un nouveau code QR.
            </p>
          </div>

          <div style={{ width: 170, margin: "0 auto", marginBottom: 0 }}>
            <Lottie animationData={successAnim} loop={true} autoplay />
          </div>

            <p className={`text-center mt-4 mb-4 countdown-text ${countdown <= 5 ? "red-text" : "text-muted"}`}>
                Redirection dans <strong>{countdown}</strong> seconde{countdown > 1 ? "s" : ""}...
            </p>


          <Button
            type="submit"
            style={{ backgroundColor: "#2848FF" }}
            className="login-btn mt-0"
            onClick={() => navigate("/login-merchant")}
          >
            Se connecter
          </Button>
        </div>
      </div>

      <div className="right-box">
        <img src={ImageLogin} alt="Logo" className="login-logo" />
      </div>
    </div>
  );
};

export default QRCodeResetSuccess;
